import { Component, Input } from '@angular/core';

/**
 * Generated class for the CommonHeaderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */


@Component({
  selector: 'state-footer',
  templateUrl: 'state-footer.html'
})
export class StateFooterComponent {

  
  @Input() showTravelLeave: boolean = false;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/state-footer/state-footer.ts